import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import registerServiceWorker from './registerServiceWorker'
import './index.css'

import * as firebase from 'firebase'

import * as moment from 'moment'
import 'moment/locale/ro'
import { capitalize } from './helpers'

moment.locale('ro')

// injectTapEventPlugin()

var firebaseConfigDev = {
  apiKey: 'AIzaSyBfZpKdu-Sv_ALjyw4sNwAcFTujLlnmwio',
  authDomain: 'ordinul-asistentilor.firebaseapp.com',
  databaseURL: 'https://ordinul-asistentilor.firebaseio.com',
  projectId: 'ordinul-asistentilor',
  storageBucket: 'ordinul-asistentilor.appspot.com',
  messagingSenderId: '1098116359327',
}

var firebaseConfigProd = {
  apiKey: 'AIzaSyAL7cIS9fQiwrBaKelcCJOve_Wuvx370xI',
  authDomain: 'oammr-timis.firebaseapp.com',
  databaseURL: 'https://oammr-timis.firebaseio.com',
  projectId: 'oammr-timis',
  storageBucket: 'oammr-timis.appspot.com',
  messagingSenderId: '73823082142',
}

let isInitialized = false

const firebaseApp = firebase.initializeApp(firebaseConfigProd)

// console.log(students)
// Object.keys(students).map(studentId => {
//   const student = students[studentId]
//   const studentData = {
//     ...student,
//     password: null,
//     firstName: capitalize(student.firstName),
//     lastName: capitalize(student.lastName),
//   }
//   console.log('student id', studentId, studentData)
//   firebase
//     .database()
//     .ref(`students/${studentId}`)
//     .update(studentData)
//     .then(res => console.log('it is done'))
// })

// Need to wait for the initial render to see if the user is already logged in or not
firebase.auth().onAuthStateChanged(user => {
  if (!isInitialized) {
    console.log('user state changed', user)
    ReactDOM.render(<App />, document.getElementById('root'))
    // registerServiceWorker()
    isInitialized = true

    // const queryAllUsers = firebase.functions().httpsCallable('queryAllUsers')
    // queryAllUsers({}).then(res => console.log(res))

    // sendEmail({
    //   emails: ['caba.ciprian@gmail.com'],
    //   subject: 'Hellow world',
    //   message: 'Sa vedem ca mere',
    // })
    //   .then(res => console.log(res.data))
    //   .catch(err => console.error(err))

    /* UPDATE STUDENTS NAMES TO CORRECT CASING 
    firebase
      .database()
      .ref('students')
      .once('value')
      .then(response =>
        response.forEach(child => {
          let student = child.val()
          let id = child.key
          let updateData = {
            firstName: capitalize(student.firstName),
            lastName: capitalize(student.lastName),
          }
          console.log('update id: ', id, 'with values', updateData)
          firebase
            .database()
            .ref(`students/${id}`)
            .update(updateData)
            .then(res => console.log('it is done'))
        }),
      )
      */

    // return firebase
    //   .database()
    //   .ref('courses')
    //   .once('value')
    //   .then(function(response) {
    //     response.forEach(function(childSnapshot) {
    //       let childObj = { ...childSnapshot.val(), id: childSnapshot.key }
    //       console.log(childObj.days.day1.attendance)
    //       firebase
    //         .database()
    //         .ref(`courses/${childSnapshot.key}/attendance`)
    //         .set(childObj.days.day1.attendance || {})
    //     })
    //   })
  }
})

// for (var i = 0; i < 7; i++) {
//   var newCourseKey = firebaseApp.database().ref().child('courses').push().key
//   firebaseApp.database().ref('/courses/' + newCourseKey).set({
//     name: 'Curs ' + (i + 1),
//     order: i + 1,
//     date: '1506852000',
//     duration: 60,
//     days: {
//       day1: { date: 1506852000, duration: 60 },
//       day2: { date: 1506952000, duration: 90 },
//       day3: { date: 1507052000, duration: 120 },
//     },
//     status: 'upcoming',
//     credits: 30,
//     attendees: 0,
//     instructors: {
//       EvHpsVqvuxaBNVpG745Ajl3kR7s1: true,
//     },
//   })

//   firebaseApp
//     .database()
//     .ref('/courseDetails/upcoming/' + newCourseKey)
//     .set(true)
// }



// WEBPACK FOOTER //
// ./src/index.js